import React from 'react';

import ItemView from './ItemView';

class HistoryItem extends React.Component {
  state = { active: false };

  handleItemClick = () => {
    const { active } = this.state;
    this.setState({ active: !active });
  };

  render = () => {
    const { active } = this.state;
    return (
      <ItemView
        active={active}
        onItemClick={this.handleItemClick}
        {...this.props}
      />
    );
  };
}

export default HistoryItem;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/index.js